import { ReactComponent as MenuIcone } from 'lauria/assets/images/mobile/menuIcon.svg'
import { ReactComponent as MenuIconeDark } from 'lauria/assets/images/mobile/menuIconDark.svg'
import { ReactComponent as FilterButton } from 'lauria/assets/images/mobile/filterButton.svg'
import { ReactComponent as FilterButtonDark } from 'lauria/assets/images/mobile/filterButtonDark.svg'
import { ReactComponent as TagButton } from 'lauria/assets/images/tags/tagButton.svg'
import { ReactComponent as TagButtonDark } from 'lauria/assets/images/tags/tagButtonDark.svg'
import { ReactComponent as PlusButton } from 'lauria/assets/images/mobile/plusButton.svg'
import { ReactComponent as PlusButtonDark } from 'lauria/assets/images/mobile/plusButtonDark.svg'
import { DarkThemeContext } from 'core/contexts/DarkThemeContext'
import React, { useContext, useState } from 'react'
import { generatePath, useNavigate } from 'react-router'
import { ROUTE_PATHS } from 'core/constants/routePath'

export const MobileMenu: React.FC<{
  openFilterModal: () => void
  displayAddButton?: boolean
}> = ({ openFilterModal, displayAddButton = true }) => {
  const { isDarkTheme } = useContext(DarkThemeContext)
  const navigate = useNavigate()
  const [hide, setHide] = useState<boolean>(true)
  const displayMenu = () => {
    setHide(!hide)
  }
  const goToTagOptions = () => {
    navigate(generatePath(ROUTE_PATHS.TAG_ADMIN))
  }
  const goToNewApp = () => {
    navigate(generatePath(ROUTE_PATHS.APPLICATION_CREATION))
  }
  return (
    <div
      className="md:hidden absolute bottom-3.5 gap-x-[10px] right-3.5 flex flex-row items-center"
      onClick={displayMenu}
    >
      {isDarkTheme ? (
        <>
          <TagButtonDark
            className={`${hide ? 'hidden' : ''}`}
            onClick={goToTagOptions}
          />
          <FilterButtonDark
            className={`${hide ? 'hidden' : ''}`}
            onClick={openFilterModal}
          />
          {displayAddButton && (
            <PlusButtonDark
              className={`${hide ? 'hidden' : ''}`}
              onClick={goToNewApp}
            />
          )}
          <MenuIconeDark className="ml-[-10px]" />
        </>
      ) : (
        <>
          <TagButton
            className={`${hide ? 'hidden' : ''}`}
            onClick={goToTagOptions}
          />
          <FilterButton
            className={`${hide ? 'hidden' : ''}`}
            onClick={openFilterModal}
          />
          {displayAddButton && (
            <PlusButton
              className={`${hide ? 'hidden' : ''}`}
              onClick={goToNewApp}
            />
          )}
          <MenuIcone className="ml-[-10px]" />
        </>
      )}
    </div>
  )
}
